import type { FC } from 'react'
import { Icon, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type ICustomFieldType, FieldTypeConfig } from 'entities/CustomField'
import { type IResponseCustomField } from 'entities/Contacts/api/types'
import styles from '../styles.module.scss'

const customFieldIcon = (fieldType: ICustomFieldType | undefined) =>
  (fieldType && FieldTypeConfig[fieldType].icon) || 'textInput'

export const CustomFieldLabel: FC<{ customField: IResponseCustomField }> = ({ customField }) => (
  <span className={styles.label} aria-label={getAriaLabel('Field', 'Label')}>
    <div
      className={styles.icon}
      aria-label={getAriaLabel('FieldType', customField.type || customField.value?.type)}
    >
      <Icon icon={customFieldIcon(customField.type || customField.value?.type)} />
    </div>
    <Typography className={styles.name} variant='text-input-field-r' tag='div' ariaLabel={'name'}>
      {customField.name}
    </Typography>
  </span>
)
